export const S3_PUSH_TO_TALK_BUCKET = "ptt.2kbo.com";
